module.exports = __webpack_public_path__ + "media/images/mobile/products/banner-3bc1c412e3b8f70cf1825ef5b27b3730.jpg";